import React from 'react';
import { Icon } from './Icon.js';
export const IconPost2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "m15.25,11H2.75c-.4141,0-.75.3359-.75.75s.3359.75.75.75h12.5c.4141,0,.75-.3359.75-.75s-.3359-.75-.75-.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m9.25,14.5H2.75c-.4141,0-.75.3359-.75.75s.3359.75.75.75h6.5c.4141,0,.75-.3359.75-.75s-.3359-.75-.75-.75Z", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("circle", { cx: "5.5", cy: "5.5", r: "3.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconPost2Fill18.js.map